




















import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import permissionGuard from '@/guards/permission-guard';
import Report from './Report.vue';
import YearSelect from '../YearSelect.vue';

@Component({
  components: {
    YearSelect,
    Report,
  },
  beforeRouteEnter(to, from, next) {
    permissionGuard('canCreatePaychecks', to, from, next)
      .catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class VacationMoneyReport extends Vue {
  @Prop({ type: Number, required: true }) private year!: number;
  @Ref() private readonly report!: Report;

  private refetchVacationMoneyReport(): void {
    this.report.fetchSettingsAndReport();
  }
}
